import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { GroupListStateService } from '@modules/contacts/services/group-list-state.service';
import { GroupsService } from '@modules/contacts/services/groups.service';
import { Group } from '@modules/contacts/types/group';
import { GroupsFilters } from '@modules/contacts/types/groups-filters';
import { GroupsListState } from '@modules/contacts/types/groups-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-groups-section',
  templateUrl: './groups-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...GroupListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeGroupsSectionComponent
  extends KnowledgeStitchSectionComponent<Group, GroupsFilters>
  implements OnInit
{
  protected readonly listStateService = inject(GroupListStateService, { self: true });
  protected readonly stitchService = inject(GroupsService);

  public override ngOnInit(): void {
    this.state = new GroupsFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: GroupsListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new GroupsFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
